"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.startInactivityTimeout = exports.stopInactivityTimeout = exports.resetInactivityTimeout = void 0;
var config_1 = __importDefault(require("./config"));
var throttle_1 = __importDefault(require("./throttle"));
var updateActiveTimestamp_1 = __importDefault(require("./updateActiveTimestamp"));
var inactivityTimeOutId = 0;
var inactivityWarningTimeOutId = 0;
var isStarted = false;
var isWarning = false;
var callback = {
    inactive: function () { return ({}); },
    inactiveWarning: function () { return ({}); }
};
var start = function () {
    var _a = config_1.default.config, sessionInactivityExpiryTime = _a.sessionInactivityExpiryTime, sessionInactivityWarningTime = _a.sessionInactivityWarningTime;
    inactivityTimeOutId = window.setTimeout(function () {
        callback.inactive();
        stop();
        removeAllEventListeners();
    }, sessionInactivityExpiryTime);
    inactivityWarningTimeOutId = window.setTimeout(function () {
        isWarning = true;
        callback.inactiveWarning();
    }, sessionInactivityWarningTime);
    isStarted = true;
};
var stop = function () {
    window.clearTimeout(inactivityTimeOutId);
    window.clearTimeout(inactivityWarningTimeOutId);
    isStarted = false;
    isWarning = false;
};
var onStorageEvent = function (event) {
    if (event.key === "activeTimestamp") {
        exports.resetInactivityTimeout();
    }
};
var onInteraction = throttle_1.default(function () {
    updateActiveTimestamp_1.default();
    exports.resetInactivityTimeout();
}, 1000);
var removeEventListener = function (event) {
    document.removeEventListener(event, onInteraction);
};
var addEventListener = function (event) {
    document.addEventListener(event, onInteraction, {
        passive: true
    });
};
var removeAllEventListeners = function () {
    removeEventListener("scroll");
    removeEventListener("mousemove");
    removeEventListener("mousedown");
    removeEventListener("keypress");
    removeEventListener("touchmove");
    window.removeEventListener("storage", onStorageEvent);
};
var addAllEventListeners = function () {
    addEventListener("scroll");
    addEventListener("mousemove");
    addEventListener("mousedown");
    addEventListener("keypress");
    addEventListener("touchmove");
    window.addEventListener("storage", onStorageEvent);
};
var resetInactivityTimeout = function () {
    if (!isStarted || isWarning) {
        return;
    }
    stop();
    start();
};
exports.resetInactivityTimeout = resetInactivityTimeout;
var stopInactivityTimeout = function () {
    removeAllEventListeners();
    stop();
};
exports.stopInactivityTimeout = stopInactivityTimeout;
var startInactivityTimeout = function (inactiveWarningCallback, inactiveCallback) {
    exports.stopInactivityTimeout();
    addAllEventListeners();
    callback.inactive = inactiveCallback;
    callback.inactiveWarning = inactiveWarningCallback;
    start();
};
exports.startInactivityTimeout = startInactivityTimeout;
